import { STORAGE_UTILITIES, StorageUtilities } from '../storage';

export const LOCAL_STORAGE: StorageUtilities = STORAGE_UTILITIES(typeof window === 'undefined' ? ({} as Storage) : window?.localStorage);
